import { $getSelection, $isRangeSelection, type BaseSelection } from "lexical";
import {
  $isTableSelection,
  $isTableCellNode,
  $isTableRowNode,
  $isTableNode,
  TableCellNode,
} from "@lexical/table";
import { $getNearestNodeOfType } from "@lexical/utils";

export function isSelectionInTable(): boolean {
  const selection: BaseSelection | null = $getSelection();
  if (!selection) return false;

  if ($isTableSelection(selection)) return true;

  if ($isRangeSelection(selection)) {
    const anchorNode = selection.anchor.getNode();

    const cell = $getNearestNodeOfType(anchorNode, TableCellNode);
    if (cell) return true;

    const nodes = selection.getNodes();
    for (const node of nodes) {
      if ($isTableNode(node) || $isTableRowNode(node) || $isTableCellNode(node)) return true;
    }
  }

  return false;
}
